import React, { useState, useEffect } from 'react';
import { ArrowUpRight } from 'lucide-react';
import serviceBanner from '../../assets/img/servicepage/service-banner.png';

const ServiceCloud = ({ overline, subtitle, buttonText }) => {
  const [typedText, setTypedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const typingString = "Engineers & Contractors";

  useEffect(() => {
    let typingSpeed = isDeleting ? 40 : 80; // Deleting is faster

    if (!isDeleting && typedText === typingString) {
      // Wait at the end of typing
      setTimeout(() => setIsDeleting(true), 2000);
      return;
    } else if (isDeleting && typedText === "") {
      // Switch back to typing
      setIsDeleting(false);
      return;
    }

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setTypedText(typingString.substring(0, typedText.length + 1));
      } else {
        setTypedText(typingString.substring(0, typedText.length - 1));
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [typedText, isDeleting]);

  return (
    <section className="service-cloud">
      <div
        className="service-cloud-bg"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url('${serviceBanner.src || serviceBanner}')`,
        }}
      ></div>
      <div className="service-cloud-content">
        {overline && <div className="service-cloud-overline">{overline}</div>}

        <h1 className="service-cloud-title">
          <span style={{ color: '#54b248' }}>Point Cloud to BIM Service USA for</span> | <span style={{ position: 'relative', display: 'inline-block' }}>
            <span style={{ visibility: 'hidden', whiteSpace: 'pre-wrap' }}>{typingString}</span>
            <span style={{ position: 'absolute', left: 0, top: 0, display: 'inline-block', width: '100%', textAlign: 'left', whiteSpace: 'pre-wrap' }}>{typedText}</span>
          </span>
        </h1>

        <p className="service-cloud-subtitle">
          {subtitle}
        </p>

        <div className="service-cloud-btn-container">
          <button className="service-cloud-btn">
            {buttonText} <ArrowUpRight size={22} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServiceCloud;
